module.exports = __webpack_public_path__ + "img/img-ab3cea3c.95e953e0.png";